import { Routes } from '@angular/router';

import { freezeDeep } from './../../utils';
import { PageComponent } from './../components/page/page.component';

export const DEFAULT_ROUTES: Routes = freezeDeep([
  {
    path: '**',
    component: PageComponent
  }
]);
